import { render, staticRenderFns } from "./NsTopnavNavigation.vue?vue&type=template&id=859df9da&scoped=true&"
import script from "./NsTopnavNavigation.vue?vue&type=script&lang=js&"
export * from "./NsTopnavNavigation.vue?vue&type=script&lang=js&"
import style0 from "./NsTopnavNavigation.vue?vue&type=style&index=0&id=859df9da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "859df9da",
  null
  
)

export default component.exports